import React from 'react';
// @ts-ignore
import styles from './HealthPlanDiabetesEducationMaterialsCustomHeader.module.scss';
import Text from '../../../../../Components/Base/Text/Text';

const HealthPlanDiabetesEducationMaterialsCustomHeader: React.FC = () => (
	<div className={styles.wrapper}>
		<Text tx='diabetes.healthPlanDefaultChange' className={styles.text} />
	</div>
);

export default HealthPlanDiabetesEducationMaterialsCustomHeader;
